import { render, staticRenderFns } from "./categoryTableDevice.vue?vue&type=template&id=0c41efad&scoped=true"
import script from "./categoryTableDevice.vue?vue&type=script&lang=js"
export * from "./categoryTableDevice.vue?vue&type=script&lang=js"
import style0 from "./categoryTableDevice.vue?vue&type=style&index=0&id=0c41efad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c41efad",
  null
  
)

export default component.exports